import React from 'react';
import { getCompanyStats } from '../../config/companyStats';

// Four-stat strip after the ROI section. Verifiable claims by default
// (config/companyStats.js); each value + label is admin-editable from the
// Storefront panel.
export default function StatsSection({ settings }) {
  const stats = getCompanyStats(settings);
  return (
    <section className="asg-stats">
      <div className="asg-stats-inner">
        {stats.map((st, i) => (
          <div className="asg-reveal" key={i}>
            <div className="asg-stat-num">{st.num}</div>
            <div className="asg-stat-label">{st.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
